__turbopack_context__.v({
  "button": "button-module__ZfeJCG__button",
  "content": "button-module__ZfeJCG__content",
  "destructive": "button-module__ZfeJCG__destructive",
  "inverse": "button-module__ZfeJCG__inverse",
  "large": "button-module__ZfeJCG__large",
  "left": "button-module__ZfeJCG__left",
  "link": "button-module__ZfeJCG__link",
  "loading": "button-module__ZfeJCG__loading",
  "loadingContainer": "button-module__ZfeJCG__loadingContainer",
  "loadingIcon": "button-module__ZfeJCG__loadingIcon",
  "medium": "button-module__ZfeJCG__medium",
  "primary": "button-module__ZfeJCG__primary",
  "right": "button-module__ZfeJCG__right",
  "secondary": "button-module__ZfeJCG__secondary",
  "small": "button-module__ZfeJCG__small",
  "spin": "button-module__ZfeJCG__spin",
  "tertiary": "button-module__ZfeJCG__tertiary",
});
